import React from "react";
import {
  StyleProp,
  ViewStyle,
  TouchableOpacity,
  View,
  Text,
  StyleSheet,
} from "react-native";
import { UsersPermissions_User } from "../api/models/UsersPermissions_User";
import { colors } from "../common/styles/colors";
import { fonts } from "../common/styles/fonts";
import { UserAvatar } from "./user-avatar";
import { StarIcon } from "../common/icons/star_small";
import { UserVotedIcon } from "../common/icons/voted";

export function UserCard({
  user,
  containerStyle,
  voted,
  isAuthor = true,
}: {
  user: UsersPermissions_User;
  containerStyle?: StyleProp<ViewStyle>;
  voted: boolean;
  isAuthor?: boolean;
}) {
  return (
    <View style={[styles.userContainer, containerStyle]}>
      <View>
        <UserAvatar user={user} size={56} />
        {voted && (
          <UserVotedIcon
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
            }}
          />
        )}
      </View>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {isAuthor && <StarIcon />}
        <Text
          style={[
            fonts.little_regular,
            { color: colors.black },
          ]}
        >
          {user.nametag}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  userContainer: {
    width: 58,
    height: 74,
    justifyContent: "space-between",
    alignItems: "center",
  },
});
